import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import IMenuItem from '../../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../../common/widgets/mainLayout';
import LanguageUtils from '../../../utils/LanguageUtils';
import UrlConstants from '../../../constants/UrlConstants';
import Pagination from '../../../interfaces/common/pagination';
import Paging from '../../../interfaces/common/paging';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import PageUtils from '../../../utils/pageUtils';
import ReportHeaderFilters from '../../../interfaces/filters/reportHeaderFilters';
import ReportHeader004 from '../../../interfaces/output/ReportHeader004';
import ReportHeader004Filters from '../../../interfaces/filters/reportHeader004Filters';
import { exportReportHeader004CSV, fetchReportHeader004, getReportHeaders004, isLoadingReportHeader004, resetReportHeader004 } from '../../../reducers/reportsReducer';
import ReportHeader004FiltersComponent from './reportHeader004Filter';
import ReportHeaders004List from './reportHeader004List';

interface IReportHeader004Props {
    classes: any;
    isLoading: boolean;
    onChange: () => void;
    resetReportHeader004: () => void;
    fetchReportHeader004: any;
    fetch: any;
    reportHeaders004: Pagination<ReportHeader004>;
    match: any;
    exportReportHeader004CSV: any;
}

interface IReportHeader004State {
    filters: ReportHeader004Filters;
    menuItem: IMenuItem;
    paging: Paging;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    reportHeader: LanguageUtils.createMessage('Report Header004'),
    downloadCSV: LanguageUtils.createMessage('Download CSV')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    exportReportHeader004CSV: (filters: ReportHeader004Filters) => dispatch(exportReportHeader004CSV({
        filters
    })),
    fetchReportHeader004: (paging: Paging, filters: ReportHeader004Filters) => dispatch(fetchReportHeader004({
        paging,
        filters
    })),
    resetReportHeader004: () => dispatch(resetReportHeader004())
});

const mapStoreToProps = (store: RootState) => ({
    isLoading: isLoadingReportHeader004(store),
    reportHeaders004: getReportHeaders004(store)
});

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class ReportHeaders004 extends Component<IReportHeader004Props, IReportHeader004State> {
    reportHeaders004Ref: any;
    constructor(props: IReportHeader004Props) {
        super(props);

        this.state = {
            filters: {} as ReportHeader004Filters,
            menuItem: {
                id: 1,
                name: messages.reportHeader,
                icon: <FontAwesomeIcon icon="table" size="1x" transform="grow-7" />,
                isSelected: false
            },
            paging: PageUtils.getDefaultPaging([{
                field: 'departureMonth',
                sort: 'asc' as GridSortDirection
            } as GridSortItem]),
            sortModel: [{
                field: 'departureMonth',
                sort: 'asc' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchReportHeader004 } = this.props;
        const { paging, filters } = this.state;

        const newFilter = {
            ...filters
        } as ReportHeaderFilters;

        fetchReportHeader004(paging, newFilter);
    }

    componentWillUnmount() {
        const { resetReportHeader004 } = this.props;
        resetReportHeader004();
    }

    exportCSV = () => {
        const { exportReportHeader004CSV } = this.props;
        const { filters } = this.state;

        exportReportHeader004CSV(filters);
    }

    applyFilters = () => {
        const { fetchReportHeader004 } = this.props;
        const { paging, filters } = this.state;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        const newFilter = {
            ...filters
        } as ReportHeader004Filters;

        this.setState({
            paging: newPagination,
            filters: newFilter
        });

        fetchReportHeader004(newPagination, newFilter);

        if(this.reportHeaders004Ref !== null && this.reportHeaders004Ref !== undefined &&
            this.reportHeaders004Ref.current !== null && this.reportHeaders004Ref.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeaders004Ref.current.resetDataGridPage();
        }
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;

        const newFilter = { ...filters } as ReportHeader004Filters;
        (newFilter as any)[attribute] = value;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    setDefaultState = () => {
        const { fetchReportHeader004 } = this.props;
        const { paging } = this.state;

        const newSortModel = [{
            field: 'departureMonth',
            sort: 'asc'
        }] as GridSortModel;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        const newFilters = {
        } as ReportHeader004Filters;

        this.setState({
            filters: newFilters,
            paging: newPagination
        });

        fetchReportHeader004(newPagination, newFilters);

        if(this.reportHeaders004Ref !== null && this.reportHeaders004Ref !== undefined &&
            this.reportHeaders004Ref.current !== null && this.reportHeaders004Ref.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeaders004Ref.current.resetDataGridPage();
        }
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchReportHeader004 } = this.props;
        const { sortModel, filters, paging } = this.state;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };
            const newFilter = {
                ...filters
            } as ReportHeaderFilters;

            this.setState({
                sortModel: newModel,
                paging: newPaging,
                filters: newFilter
            });

            fetchReportHeader004(newPaging, newFilter);

        }
    }

    render() {
        const { classes, isLoading, fetchReportHeader004, reportHeaders004 } = this.props;
        const { filters, menuItem, paging, columnVisibilityModel } = this.state;

        return (
            <MainLayout menuItem={menuItem}
                routes={
                    [{
                        name: 'go to prev page',
                        url: `${UrlConstants.REPORTS}`
                    }]}
            >
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <ReportHeader004FiltersComponent
                                    actions={[{
                                        text: messages.downloadCSV,
                                        icon: 'download',
                                        onClick: this.exportCSV
                                    }]}
                                    applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                <ReportHeaders004List
                                    rows={reportHeaders004} isLoading={isLoading}
                                    ref={this.reportHeaders004Ref}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        const newFilter = {
                                            ...filters
                                        } as ReportHeader004Filters;
                                        fetchReportHeader004(newPage, newFilter);
                                        this.setState({
                                            paging: newPage,
                                            filters: newFilter
                                        });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ReportHeaders004));